import { appThemeStyle } from "@/constants/theme.config";
import { isAlertDetail } from "@/utils/isAlertDetail";
import { omit } from "lodash";
import { homeAtom } from "@/atoms/home";
const transparentStyle = { background: "transparent", backdropFilter: "none", boxShadow: "none" };
const BaseContent: React.FC<any> = forwardRef<any, any>(
  ({ children, style, useTransparentStyle = false, ...args }, contentRef) => {
    const locInfo = LocalStorage.getItem("INFO");
    const homeData = useAtomValue(homeAtom);
    const weatherStatus = homeData?.data?.info?.weatherStatus || locInfo?.weatherStatus;
    const mainItemStyle = appThemeStyle?.[weatherStatus]?.mainItemStyle ?? {};
    const _isAlertDetail = isAlertDetail();
    const _mainItemStyle = useTransparentStyle ? transparentStyle : mainItemStyle;
    // 移除 style 中的 background 相关简写属性，避免冲突
    const cleanStyle = omit(style || {}, [
      "background",
      "backgroundImage",
      "backgroundPosition",
      "backgroundSize",
      "backgroundRepeat",
    ]);

    const contentStyle = { ...cleanStyle, ..._mainItemStyle };

    const finalStyle = {
      ...contentStyle,
      ...(_isAlertDetail ? { ..._mainItemStyle } : {}),
    };
    return (
      <div ref={contentRef} style={finalStyle} {...args}>
        {children}
      </div>
    );
  },
);
export default BaseContent;
